import React from 'react';
import styled from 'styled-components';

import { Flex, Icons, Typography } from 'components';

const SecurityIcon = styled(Icons)`
  color: ${({ theme }) => theme.colors.dark_350};
  flex-shrink: 0;

  ${({ theme: { mediaQueries } }) => {
    return `
      width: 25px;

      ${mediaQueries.desktop} {
        width: 35px;
      }
    `;
  }}
`;

const MethodFlag = styled.img`
  width: 32px;
  height: 24px;
  margin-right: 10px;
  margin-top: 10px;
`;

interface SafeBuyFooterProps {
  freeOffer: boolean;
}

const SafeBuyFooter = React.memo(({ freeOffer }: SafeBuyFooterProps) => {
  const paymentsMethods = [
    { name: 'American Express', flag: 'amex' },
    { name: 'Diners Club', flag: 'diners' },
    { name: 'ELo', flag: 'elo' },
    { name: 'Aura', flag: 'aura' },
    { name: 'Banes', flag: 'banes' },
    { name: 'Discover', flag: 'discover' },
    { name: 'Hiper', flag: 'hiper' },
    { name: 'Hipercard', flag: 'hipercard' },
    { name: 'JCB', flag: 'jcb' },
    { name: 'Maestro', flag: 'maestro' },
    { name: 'Mastercard', flag: 'mastercard' },
    { name: 'Visa', flag: 'visa' },
  ];

  return !freeOffer ? (
    <Flex flexDirection="column">
      <SecurityIcon icon="shieldLock" />

      <Typography type="type2" fontWeight="bold" mt={2}>
        Compra 100% segura
      </Typography>

      <Typography type="type1" color="gray_500" mt={2}>
        O processamento de seus dados bancários é feito preservando a segurança e confidencialidade de todas as suas informações.
      </Typography>

      <Typography type="type2" fontWeight="bold" mt={3}>
        Metodos de pagamentos aceitos
      </Typography>

      <Flex>
        {paymentsMethods.map((method) => {
          return <MethodFlag key={`creditCard-brand-${method.flag}`} src={`/images/paymentsFlags/${method.flag}.png`} title={method.name} />;
        })}
      </Flex>
    </Flex>
  ) : (
    <></>
  );
});

export default SafeBuyFooter;
